<template>
  <div id="app">
    <a href="#main-content" class="skip-link">Skip to Main content</a>
    <Loader v-if="$store.state.formSubmitLoading" />
    <header>
      <nav class="navbar navbar-light bg-white mb-5">
        <div
          class="container justify-content-center justify-content-md-between"
        >
          <a class="navbar-brand" href="#">
            <img
              :src="'./assets/Colonnade-logo.png'"
              alt="Colonnade logo"
              style="max-width: 300px; height: auto;"
            />
          </a>
        </div>
      </nav>
      <div class="container">
        <div
          class="mb-3 ms-md-auto flex-grow-1 w-100 w-md-auto flex-md-grow-0 connection"
        >
          {{ datas.connection }}
          <div v-if="datas.product_code">
            {{ " Kalkuláció azonosítója:" + datas.product_code }}
          </div>
        </div>
        <NavigationTop />
        <div class="alert alert-light text-center mb-4">
          <p v-if="$store.state.page == 1" class="h5 m-0">
            <template v-if="isMFO && $store.state.marks.mfo_uzenet">
              <span v-html="$store.state.marks.mfo_uzenet"></span>
            </template>
            <!-- <template v-else>
              Köszöntjük a Colonnade Édes Otthon Lakásbiztosítás online kötőfelületén!<br /><br />
              Kérjük, adja meg az alábbi adatokat ahhoz, hogy elkészíthessük az Ön számára
              legideálisabb biztosítási ajánlatot.
            </template> -->
            <template v-else>
              <!-- RÉGI -->
              <div>
                Kalkuláljon és kössön most akár
                <span class="percentage">48% kedvezménnyel</span> Colonnade Édes
                Otthon Lakásbiztosítást!
              </div>
              <p class="smalltext">
                A biztosítás díjából kedvezményt adunk elektronikus kommunikáció
                (5%), valamint elektronikus kárrendezés (5%), éves (8%) vagy
                féléves (4%) díjfizetési gyakoriság alapján (max.8%), valamint
                fizetési módok alapján (max.5%). Ezenfelül további kedvezményt
                biztosítunk a szerződő életkora, illetve a kockázatviselésünket
                befolyásoló egyéb tényezők alapján (max. 25%).
              </p>
              <!-- RÉGI -->
              <!-- <div>
                Kalkuláljon és kössön most akár
                <span class="percentage">48% kedvezménnyel *</span> Colonnade
                Édes Otthon Lakásbiztosítást!
              </div>
              <br />
              <div>
                2026. március 1. és április 30. között a lakásbiztosítása mellé
                díjmentesen választhat
                <span class="percentage">
                  Bérlői felelősségbiztosítás fedezetet,</span
                >
                valamint
                <span class="percentage">
                  300 000 Ft értékig Okos Otthon fedezetet,</span
                >
                a szerződés teljes időtartamára.
              </div>
              <p class="smalltext">
                * A biztosítás díjából kedvezményt adunk elektronikus
                kommunikáció (5%), valamint elektronikus kárrendezés (5%), éves
                (8%) vagy féléves (4%) díjfizetési gyakoriság alapján (max.8%),
                valamint fizetési módok alapján (max.5%). Ezenfelül további
                kedvezményt biztosítunk a szerződő életkora, illetve a
                kockázatviselésünket befolyásoló egyéb tényezők alapján (max.
                25%).
              </p> -->
            </template>
          </p>
          <p v-else-if="$store.state.page == 2" class="h5 m-0">
            Az alábbiakban lehetősége nyílik további kiegészítő fedezeteket
            választania.
          </p>
          <p v-else-if="$store.state.page == 3" class="h5 m-0">
            Kérjük, válasszon az alábbi díjfizetési módok és díjfizetési
            gyakoriságok közül.
          </p>
          <p v-else-if="$store.state.page == 4" class="h5 m-0">
            Kérjük, adja meg a biztosítani kívánt ingatlan és a szerződő
            adatait!
          </p>
          <p v-else-if="$store.state.page == 5" class="h5 m-0">
            Kérjük, ellenőrizze az alábbi összesítést, és győződjön meg a
            korábban megadott adatok helyességéről! Ha mindent rendben talált,
            az oldal alján található nyilatkozatok elfogadásával véglegesítheti
            a biztosítási szerződést.
          </p>
          <p v-if="$store.state.page < 5" class="h5 m-0">
            <br />
            A Colonnade Édes Otthon Lakásbiztosítás
            <a
              class="alert-link"
              target="”_blank”"
              href="https://www.colonnade.hu/media/colonnade-edes-otthon-lakasbiztositas-biztositasi-termekismerteto-ipid"
              >termékismertetője</a
            >
            és
            <a
              class="alert-link"
              target="”_blank”"
              href="https://www.colonnade.hu/media/colonnade-edes-otthon-lakasbiztositas-biztositasi-feltetelek-es-ugyfeltajekoztato"
            >
              szabályzata.
            </a>
          </p>
        </div>
      </div>
    </header>
    <div id="main-content" class="container">
      <!--  innentől main -->
      <PriceTracker v-if="$store.state.page == 2" />
      <h2 class="text-danger mb-2" v-if="$store.state.generalErrors.length > 0">
        Hibák
      </h2>
      <ul class="text-danger mb-5" v-if="$store.state.generalErrors.length > 0">
        <li
          v-for="(error, key) in $store.state.generalErrors"
          :key="`gerror-${key}`"
        >
          {{ error }}
        </li>
      </ul>
      <OverallData v-if="$store.state.page > 2 && $store.state.page < 5" />
      <ValidationObserver v-slot="{ invalid, validate }">
        <form id="form">
          <FirstPage
            v-if="$store.state.page >= 1"
            v-show="$store.state.page === 1"
            :validate="validate"
          />
          <SecondPage
            v-if="$store.state.page >= 2"
            v-show="$store.state.page === 2"
          />
          <ThirdPage
            v-if="$store.state.page >= 3"
            v-show="$store.state.page === 3"
          />
          <FourthPage
            v-if="$store.state.page >= 4"
            v-show="$store.state.page === 4"
          />
          <FifthPage
            v-if="$store.state.page >= 5"
            v-show="$store.state.page === 5"
          />
        </form>
        <Navigation v-bind:invalid="invalid" :validate="validate" />
        <p
          v-show="invalid"
          class="h6 mb-3 text-center text-md-end text-danger"
          id="invalid_inputs"
        >
          Kérjük töltse ki a csillaggal (*) megjelölt mezőket.
        </p>
        <p v-if="$store.state.page === 5" class="text-justify">
          A fenti gomb megnyomásával kijelentem, hogy jelen ajánlatban
          részletezett feltételekkel ajánlatot teszek a Colonnade Édes Otthon
          Lakásbiztosítás szerződés megkötésére a Colonnade Insurance S.A.
          Magyarországi Fióktelepe részére. Kijelentem, hogy a jelen Biztosítási
          ajánlatban feltüntetett adatok a valóságnak megfelelnek, a valótlan
          adatok közlése pedig a biztosítási szerződés érvénytelenségét vonja
          maga után. A létrejött Biztosítási szerződés alapján a Biztosító
          díjfizetés ellenében arra vállal kötelezettséget, hogy a Colonnade
          Édes Otthon Lakásbiztosítás biztosítási feltételeiben meghatározott
          kockázatokra fedezetet nyújt és a biztosítási feltételekben
          meghatározott biztosítási esemény bekövetkezése esetén a vonatkozó
          biztosítási feltételekben meghatározott szolgáltatást nyújtja.
        </p>
      </ValidationObserver>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

import FirstPage from "./components/FirstPage";
import SecondPage from "./components/SecondPage";
import ThirdPage from "./components/ThirdPage";
import FourthPage from "./components/FourthPage";
import FifthPage from "./components/FifthPage";
import NavigationTop from "./NavigationTop";
import OverallData from "./OverallData";
import Navigation from "./Navigation";
import Footer from "./Footer";
import Loader from "./components/Loader";
import RequestPdfButton from "./components/components/RequestPdfButton";
import jQuery from "jquery";

import { debounce } from "debounce";
import PriceTracker from "./components/components/PriceTracker.vue";

export default {
  components: {
    FirstPage,
    SecondPage,
    ThirdPage,
    FourthPage,
    FifthPage,
    Navigation,
    NavigationTop,
    Footer,
    OverallData,
    Loader,
    RequestPdfButton,
    PriceTracker,
  },
  data() {
    return {
      isMFO: false,
    };
  },
  computed: {
    ...mapGetters({
      datas: "getAllState",
    }),
    ...mapFields(["merchant_id", "page", "email_valid_code", "last_email"]),
    ...mapFields({
      contractorLastName: "contractSettings.lastName",
      contractorEmail: "contractSettings.email",
      contractorEmailVerification: "contractSettings.emailVerification",
    }),
    emailVerificationDatas: function() {
      return {
        email: this.contractorEmail,
        emailVerification: this.contractorEmailVerification,
        validCode: this.email_valid_code,
        lastEmail: this.lastEmail,
        lastName: this.contractorLastName,
      };
    },
  },
  methods: {
    ...mapActions([
      "verifyPage",
      "getStoredData",
      "getMarks",
      "updateMarks",
      "getSelectLists",
    ]),
    // mounted() {
    //   this.$gtm.trackView('MyScreenName', 'currentPath');
    // },
  },
  created() {
    //CSAK TESZT
    //localStorage.removeItem('storage_uid');
    //localStorage.removeItem('last_interaction');
    localStorage.removeItem("storage_uid");
    localStorage.removeItem("last_interaction");
    // localStorage.clear();
    //CSAK TESZT VÉGE
    this.getMarks();
    this.getSelectLists();

    const search_params = window.location.search.substring(1).split("&");
    search_params.forEach((param) => {
      const [key, value] = param.split("=");
      if (key == "merchant_id" && value) {
        this.merchant_id = value;
        this.$store.commit("setBusinessDiscount", null);
      }
      if (key == "fetch_uid" && value)
        this.$store.dispatch("getSavedDataByUid", value);
      if (key == "rbnb" && value) {
        this.$store.commit("setGeneralPropertyValues", {
          name: "rbnb",
          value: 1,
        });
        this.$store.commit("setGeneralPropertyValues", {
          name: "rbnb",
          value: 1,
        });
        this.$store.commit("setGeneralPropertyValues", {
          name: "propertyOwnRight",
          value: "sajat_berbe",
        });
      }
    });
    this.$gtm.trackEvent({
      event: null, // Event type [default = 'interaction'] (Optional)
      category: "Calculator",
      action: "click",
      label: "Home page SIP calculator",
      value: 5000,
      noninteraction: false, // Optional
    });
    //this.verifyPage();
    //if(this.$store.state.storage_uid) this.getStoredData()
  },
  mounted() {
    jQuery(document).on("select2:open", () => {
      document.querySelector(".select2-search__field").focus();
    });
  },

  watch: {
    datas: {
      handler: debounce(function(after, before) {
        if (this.page !== 1 && this.page !== 3 && this.page !== 5) return;

        if (this.page < 5) this.verifyPage();
      }, 3000),
      deep: true,
    },
    emailVerificationDatas: {
      handler: debounce(function(after, before) {
        if (this.page !== 4) return;

        if (
          this.contractorEmail &&
          this.contractorEmailVerification &&
          (!this.email_valid_code || this.last_email != this.contractorEmail) &&
          this.contractorLastName
        ) {
          const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          if (
            !emailRegex.test(this.contractorEmail) &&
            !emailRegex.test(this.contractorEmailVerification)
          )
            return;

          if (this.contractorEmail === this.contractorEmailVerification) {
            this.verifyPage();
          }
        }
      }, 3000),
      deep: true,
    },
    page: {
      handler: debounce(function(newState, oldState) {
        if (newState > oldState) {
          this.updateMarks();
        }
      }, 1500),
    },
  },
};
</script>

<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap";

$red: #e4002b;
$danger: #e4002b;

html {
  scroll-behavior: smooth;
}

body {
  color: #555 !important;
  font-size: 14px !important;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.form-check-input {
  width: 17px !important;
  height: 17px !important;
  margin-top: 0.125em !important;
  margin-right: 0.5em;
}

label,
.label {
  margin-bottom: 3px;
  font-size: 14px;

  &.col-sm-4 {
    font-weight: bold !important;
  }
}

button.info {
  text-align: center;
  display: inline-block;
  background-color: $red;
  border-radius: 50%;
  color: white;
  max-width: 21px;
  max-height: 21px;
  width: 21px;
  height: 21px;
  line-height: 21px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-weight: bold;
  border: none;
}

h1,
h2 {
  color: $red;
  text-transform: uppercase;
  font-weight: 600 !important;
  margin: 0 0 30px !important;
  line-height: 140%;
}

h1 {
  font-size: 20px !important;
}

h2,
.h2 {
  font-size: 17px !important;
}

.datepicker > button {
  background-color: $red !important;
  border-color: $red !important;

  &:hover,
  &:focus,
  &:active {
    background-color: $red !important;
    border-color: $red !important;
  }
}

.btn-red {
  background-color: $red !important;
  color: white !important;
  font-size: 14px !important;
  padding: 8px 10px !important;
}

.btn-outline-danger {
  color: $red !important;
  border-color: $red !important;
  font-size: 14px !important;
  padding: 8px 10px !important;

  &:hover,
  &:active,
  &:focus {
    background-color: $red !important;
    color: white !important;
  }
}

.alert-dark {
  background-color: #6c757d !important;
  color: white !important;
}

.alert-light {
  color: #555 !important;
}
.alert > p > .alert-link,
label > a {
  color: #003859;
}

.datepicker-prepend-input {
  flex-grow: 1;

  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex-grow: 1;
  }
}
.swal2-close {
  color: #666;
}

.swal2-close:focus {
  outline-offset: 0 !important;
  /* outer indicator */
  box-shadow: 0 0 0 2px #000000 !important;
}

.swal2-icon {
  color: #ced4da !important;
  border-color: #ced4da !important;
}

.swal2-input-label {
  font-size: 1rem;
  color: #666;
  font-weight: bolder;
}

::selection {
  color: white;
  background: #333;
  text-shadow: none;
}
.connection {
  color: #666;
}
.smalltext {
  font-size: 12px;
  font-style: italic;
}
.percentage {
  color: $red;
}
div > .claim-identifier {
  margin: 0.5rem;
}
div > .claim-identifier:focus,
.claim-identifier:focus-visible {
  /* inner indicator */
  outline: 2px #fff solid !important;
  outline-offset: 0 !important;
  /* outer indicator */
  box-shadow: 0 0 0 4px #000 !important;
}

h2.text-danger,
ul.text-danger,
small.text-danger,
div.text-danger,
span.text-danger {
  color: $red !important;
}

small.text-warning {
  color: #b0001f !important;
}

#invalid_inputs {
  color: $red !important;
}

input.dark-border,
div.dark-border > span,
div.dark-border > div > input,
select.dark-border,
div.dark-border > div {
  border-color: #66889b !important;
}

.skip-link {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: 1;
  background: $red;
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-right: 1rem;
  padding-left: 1rem;
  margin-top: 1rem;
  margin-left: 1rem;
  font-size: large;
  z-index: 1;
  border-radius: 0.2rem;
  outline: 2px #fff solid !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 4px #000 !important;
}

.skip-link:focus,
.skip-link:focus-visible {
  top: 0;
  left: 0;
}

div.select-zip
  > div.vs__dropdown-toggle
  > div.vs__selected-options
  > input.vs__search:focus {
  outline: 2px #fff solid !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 4px #000 !important;
}

li.vs__dropdown-option--highlight {
  background-color: #33758b !important;
}

div > div.Vue-Toastification__toast--error {
  background-color: #e4002b;
}

.li.vs__dropdown-option:focus {
  border: 2px solid black;
}

.Vue-Toastification__close-button:focus {
  outline: 2px #fff solid !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 4px #000 !important;
}

div > button.add-new-item:disabled {
  background-color: #cccccc !important;
  color: #222 !important;
  border-color: #222 !important;
}
</style>
